import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

type Tone = 'neutral' | 'brand' | 'positive' | 'caution' | 'info' | 'muted'

const TONES: Record<Tone, string> = {
  neutral: 'bg-paper-muted text-ink-soft border-line',
  brand: 'bg-brand-soft text-brand border-brand-line',
  positive: 'bg-positive-soft text-positive border-positive/20',
  caution: 'bg-caution-soft text-caution border-caution/20',
  info: 'bg-info-soft text-info border-info/20',
  muted: 'bg-transparent text-ink-muted border-line',
}

export function Badge({
  tone = 'neutral',
  icon,
  children,
  className,
}: {
  tone?: Tone
  icon?: ReactNode
  children: ReactNode
  className?: string
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-medium',
        TONES[tone],
        className,
      )}
    >
      {icon}
      {children}
    </span>
  )
}

/** A dye swatch chip, used in lists, filters and comparison headers. */
export function Swatch({
  hex,
  size = 'md',
  className,
}: {
  hex: string | null | undefined
  size?: 'xs' | 'sm' | 'md' | 'lg'
  className?: string
}) {
  const sizes = { xs: 'size-3', sm: 'size-4', md: 'size-6', lg: 'size-10' }
  return (
    <span
      className={cn('inline-block shrink-0 rounded border border-line', sizes[size], className)}
      style={{ backgroundColor: hex ?? 'var(--color-paper-muted)' }}
      aria-hidden
    />
  )
}
